import type { UseFormRegisterReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Input } from '~/components/ui/input'
import { Label } from '~/components/ui/label'
import { MAX_AFFILIATION_LENGTH } from '~/helpers/users/affiliation'

type Props = {
  /** Préfixe des `id`, pour que deux formulaires du même panneau ne partagent pas les leurs. */
  idPrefix: string
  company: UseFormRegisterReturn
  department: UseFormRegisterReturn
}

/**
 * Société et service d'un utilisateur (#277), facultatifs. Partagés par la
 * création par e-mail, celle en pseudo et l'édition : les deux parcours de
 * création ne doivent pas diverger (#148).
 */
function AffiliationFields({ idPrefix, company, department }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-company`}>{t('user.company')}</Label>
        <Input id={`${idPrefix}-company`} maxLength={MAX_AFFILIATION_LENGTH} autoComplete="organization" {...company} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-department`}>{t('user.department')}</Label>
        <Input id={`${idPrefix}-department`} maxLength={MAX_AFFILIATION_LENGTH} {...department} />
      </div>
    </>
  )
}

export default AffiliationFields
